// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form = require("../../common/Components/Form.bs.js");
let React = require("react");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let MediaQuery = require("../../../reason/common/Media/MediaQuery.bs.js");
let Form__Label = require("../../common/Components/Form__Label.bs.js");
let TogglesGroup = require("../../../uikit/reason/molecules/TogglesGroup/TogglesGroup.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let Form__Checkbox = require("../../common/Components/Form__Checkbox.bs.js");
let SearchPagesUtils = require("../../common/SearchPagesUtils.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyFilterOptions = require("../../common/Form/PropertyFilterOptions.bs.js");
let ClientNeedsPageRelayQueryParams = require("./ClientNeedsPageRelayQueryParams.bs.js");
let ClientNeedFiltersAreasAutocomplete = require("../clientNeedForms/ClientNeedFiltersAreasAutocomplete.bs.js");

function ClientNeedsPageRelayFilters$PropertyTypes(props) {
  let refetch = props.refetch;
  let match = ClientNeedsPageRelayQueryParams.use();
  let params = match[0];
  let isDesktop = MediaQuery.isDesktop();
  let mobileMenu = !isDesktop;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Property Types"
      }),
      JsxRuntime.jsx(TogglesGroup.make, {
        inline: false,
        children: props.rentalMode ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.rentalNeedPropertyTypes = SearchPagesUtils.toggleIncluded(params.rentalNeedPropertyTypes, "SINGLE_FAMILY");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.rentalNeedPropertyTypes, "SINGLE_FAMILY"),
                label: "Single-family",
                mobileStyles: mobileMenu
              }),
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.rentalNeedPropertyTypes = SearchPagesUtils.toggleIncluded(params.rentalNeedPropertyTypes, "CONDO");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.rentalNeedPropertyTypes, "CONDO"),
                label: "Condo/townhouse",
                mobileStyles: mobileMenu
              })
            ]
          }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.buyerNeedPropertyTypes = SearchPagesUtils.toggleIncluded(params.buyerNeedPropertyTypes, "SINGLE_FAMILY");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.buyerNeedPropertyTypes, "SINGLE_FAMILY"),
                label: "Single-family",
                mobileStyles: mobileMenu
              }),
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.buyerNeedPropertyTypes = SearchPagesUtils.toggleIncluded(params.buyerNeedPropertyTypes, "MULTI_UNIT");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.buyerNeedPropertyTypes, "MULTI_UNIT"),
                label: "Multi-unit",
                mobileStyles: mobileMenu
              }),
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.buyerNeedPropertyTypes = SearchPagesUtils.toggleIncluded(params.buyerNeedPropertyTypes, "CONDO");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.buyerNeedPropertyTypes, "CONDO"),
                label: "Condo/townhouse",
                mobileStyles: mobileMenu
              }),
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.buyerNeedPropertyTypes = SearchPagesUtils.toggleIncluded(params.buyerNeedPropertyTypes, "LOT");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.buyerNeedPropertyTypes, "LOT"),
                label: "Lot",
                mobileStyles: mobileMenu
              })
            ]
          })
      })
    ]
  });
}

let PropertyTypes = {
  Checkbox: undefined,
  TogglesGroup: undefined,
  make: ClientNeedsPageRelayFilters$PropertyTypes
};

function ClientNeedsPageRelayFilters$AreasItem$AreasInput(props) {
  let refetch = props.refetch;
  let setSelectedAreas = props.setSelectedAreas;
  return JsxRuntime.jsx(ClientNeedFiltersAreasAutocomplete.make, {
    value: props.selectedAreas,
    onChange: v => {
      setSelectedAreas(param => v);
      refetch(undefined, undefined, undefined, params => {
        let newrecord = {...params};
        newrecord.areaIds = v.length !== 0 ? v.map(d => d.id) : undefined;
        return newrecord;
      });
    }
  });
}

let AreasInput = {
  make: ClientNeedsPageRelayFilters$AreasItem$AreasInput
};

function ClientNeedsPageRelayFilters$AreasItem(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Areas"
      }),
      JsxRuntime.jsx(ClientNeedsPageRelayFilters$AreasItem$AreasInput, {
        selectedAreas: props.selectedAreaIds.length !== 0 ? props.selectedAreas : [],
        setSelectedAreas: props.setSelectedAreas,
        refetch: props.refetch
      })
    ],
    className: "min-w-[300px]"
  });
}

let AreasItem = {
  AreasInput: AreasInput,
  make: ClientNeedsPageRelayFilters$AreasItem
};

function ClientNeedsPageRelayFilters$TANStatuses(props) {
  let refetch = props.refetch;
  let isDesktop = MediaQuery.isDesktop();
  let match = ClientNeedsPageRelayQueryParams.use();
  let params = match[0];
  let checkboxes = props.rentalMode ? [
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.active = !params.active;
          return newrecord;
        }),
        checked: params.active,
        label: "Active",
        mobileStyles: true
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.withdrawnOrExpired = !params.withdrawnOrExpired;
          return newrecord;
        }),
        checked: params.withdrawnOrExpired,
        label: "Withdrawn / Expired",
        mobileStyles: true
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.purchasedOrRented = !params.purchasedOrRented;
          return newrecord;
        }),
        checked: params.purchasedOrRented,
        label: "Rented",
        mobileStyles: true
      })
    ] : [
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.active = !params.active;
          return newrecord;
        }),
        checked: params.active,
        label: "Active",
        mobileStyles: true
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.withdrawnOrExpired = !params.withdrawnOrExpired;
          return newrecord;
        }),
        checked: params.withdrawnOrExpired,
        label: "Withdrawn / Expired",
        mobileStyles: true
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.purchasedOrRented = !params.purchasedOrRented;
          return newrecord;
        }),
        checked: params.purchasedOrRented,
        label: "Purchased",
        mobileStyles: true
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.inContract = !params.inContract;
          return newrecord;
        }),
        checked: params.inContract,
        label: "In Contract",
        mobileStyles: true
      })
    ];
  return JsxRuntime.jsxs(ViewStack.make, {
    space: "sm",
    width: isDesktop ? ({
        NAME: "px",
        VAL: "w320"
      }) : undefined,
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "TAN Status"
      }),
      isDesktop ? JsxRuntime.jsx("div", {
          children: checkboxes.map((e, i) => JsxRuntime.jsx("div", {
            children: e,
            className: "grid-span-1"
          }, i.toString())),
          className: "grid grid-cols-2 gap-2"
        }) : JsxRuntime.jsx(TogglesGroup.make, {
          inline: false,
          children: checkboxes.map((e, i) => React.cloneElement(e, {
            key: i.toString()
          }))
        })
    ]
  });
}

let TANStatuses = {
  make: ClientNeedsPageRelayFilters$TANStatuses
};

function ClientNeedsPageRelayFilters$Keywords(props) {
  let refetch = props.refetch;
  let match = ClientNeedsPageRelayQueryParams.use();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Keywords"
      }),
      JsxRuntime.jsx(Form.SearchField.make, {
        value: Stdlib_Option.getOr(match[0].keywords, []),
        onChange: value => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.keywords = value;
          return newrecord;
        }),
        placeholderText: "elevator, waterfront, fixer-upper"
      })
    ]
  });
}

let Keywords = {
  make: ClientNeedsPageRelayFilters$Keywords
};

function ClientNeedsPageRelayFilters$MinPrice(props) {
  let refetch = props.refetch;
  let match = ClientNeedsPageRelayQueryParams.use();
  let params = match[0];
  let rentalMode = params.rentalMode;
  let priceOptions = rentalMode ? PropertyFilterOptions.PriceFilters.rentalOptions : PropertyFilterOptions.PriceFilters.forSaleOptions;
  let max = params.maxPrice;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Lower Price"
      }),
      JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
        getOptionLabel: PropertyFilterOptions.Option.getOptionLabel,
        getOptionValue: PropertyFilterOptions.Option.getOptionValue,
        isClearable: true,
        onChange: e => {
          let value = Stdlib_Option.map(e, e => e.value);
          refetch(undefined, undefined, undefined, params => {
            let newrecord = {...params};
            newrecord.minPrice = value;
            return newrecord;
          });
        },
        options: max !== undefined ? priceOptions.filter(x => x.value < max) : priceOptions,
        value: Stdlib_Option.map(params.minPrice, p => ({
          value: p,
          label: PropertyFilterOptions.Option.makeLabel(p, priceOptions)
        }))
      })
    ],
    className: "flex-1 min-w-48"
  });
}

let MinPrice = {
  make: ClientNeedsPageRelayFilters$MinPrice
};

function ClientNeedsPageRelayFilters$MaxPrice(props) {
  let refetch = props.refetch;
  let match = ClientNeedsPageRelayQueryParams.use();
  let params = match[0];
  let rentalMode = params.rentalMode;
  let priceOptions = rentalMode ? PropertyFilterOptions.PriceFilters.rentalOptions : PropertyFilterOptions.PriceFilters.forSaleOptions;
  let min = params.minPrice;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Upper Price"
      }),
      JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
        getOptionLabel: PropertyFilterOptions.Option.getOptionLabel,
        getOptionValue: PropertyFilterOptions.Option.getOptionValue,
        isClearable: true,
        onChange: e => {
          let value = Stdlib_Option.map(e, e => e.value);
          refetch(undefined, undefined, undefined, params => {
            let newrecord = {...params};
            newrecord.maxPrice = value;
            return newrecord;
          });
        },
        options: min !== undefined ? priceOptions.filter(x => x.value > min) : priceOptions,
        value: Stdlib_Option.map(params.maxPrice, p => ({
          value: p,
          label: PropertyFilterOptions.Option.makeLabel(p, priceOptions)
        }))
      })
    ],
    className: "flex-1 min-w-48"
  });
}

let MaxPrice = {
  make: ClientNeedsPageRelayFilters$MaxPrice
};

let QueryParams;

let Checkbox;

let TogglesGroup$1;

let Grid;

let Cell;

let MenuItem;

exports.QueryParams = QueryParams;
exports.Checkbox = Checkbox;
exports.TogglesGroup = TogglesGroup$1;
exports.Grid = Grid;
exports.Cell = Cell;
exports.MenuItem = MenuItem;
exports.PropertyTypes = PropertyTypes;
exports.AreasItem = AreasItem;
exports.TANStatuses = TANStatuses;
exports.Keywords = Keywords;
exports.MinPrice = MinPrice;
exports.MaxPrice = MaxPrice;
/* Form Not a pure module */
